import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_MEMBERS } from '../../../actions/types';
import InfoTooltip from '../../formFields/InfoTooltip';

class Members extends React.Component {

    _onSelectedUser = (items) => {
        this.props.addMember(items);
    }
    
    render() {
        
        return (
            <div className='wizard-inside-third' style={{height: 'unset'}}>
                <div className="item-Owner">
                Members
                    <InfoTooltip content='The members will only have access to the “General” team channel, but any of the administrators can later assign them access to private channels if needed.' />
                </div>
                {/* {warning} */}
                <PeoplePicker
                    defaultUsers={this.props.member} 
                    onSelectedUsers={this._onSelectedUser} 
                    
                    // errorMessage={error}
                />
            </div>
        );
    }
}

// Approver.propTypes = {
//     addApprover: PropTypes.func.isRequired,
//     approver: PropTypes.object,
//     currentUser: PropTypes.object,
//     manager: PropTypes.object,
//     owner: PropTypes.object,
// }


const mapActionToProp = (dispatch) => ({
    addMember: (element) => { dispatch(addElement(ADD_MEMBERS, element)) }
})

const mapStateToProps  = state => ({
    currentUser: state.user.currentUser,
    member: state.newSite.Members,
    possibleWarning : state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(Members);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/Members.js